/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Sign_OrInputs */

const en_common_sign_or = /** @type {(inputs: Common_Sign_OrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Or continue with`)
};

/**
* | output |
* | --- |
* | "Or continue with" |
*
* @param {Common_Sign_OrInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_sign_or = /** @type {((inputs?: Common_Sign_OrInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Sign_OrInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_sign_or(inputs)
});
export { common_sign_or as "common.sign.or" }